import {KNOWLEDGEBASE_PATH} from 'constants/path'
import Multiknowledgebase from 'pages/authenticated/Multiknowledgebase'
import KnowledgeBaseContextProvider from 'context/knowledge-base'
import Knowledge from 'components/pages/Knowledgebase/Knowledge'
import {Outlet} from 'react-router-dom'

const knowledgebaseRoutes = [
  {
    path: KNOWLEDGEBASE_PATH.PREFIX,
    handle: {title: 'Knowledgebase'},
    element: (
      <KnowledgeBaseContextProvider>
        <Outlet />
      </KnowledgeBaseContextProvider>
    ),
    children: [
      {
        index: true,
        element: <Multiknowledgebase />,
      },
      {
        path: ':id',
        element: <Knowledge />,
        children: [
          {
            index: true,
            lazy: () => import('components/pages/Knowledgebase/KnowledgeBaseHome'),
          },
          {
            path: KNOWLEDGEBASE_PATH.ARTICLES,
            handle: {title: 'Articles'},
            lazy: () => import('components/pages/Knowledgebase/Articles/Articles'),
          },
          {
            path: `${KNOWLEDGEBASE_PATH.ARTICLES}/:articleId/version/:versionId`,
            handle: {title: 'Version Control'},
            lazy: () => import('components/pages/Knowledgebase/Articles/ArticleVersion'),
          },
          {
            path: `${KNOWLEDGEBASE_PATH.ARTICLES}/:articleId/${KNOWLEDGEBASE_PATH.VERSION_CONTROL}/:versionIds`,
            handle: {title: 'Version Control'},
            lazy: () => import('components/pages/Knowledgebase/Articles/VersionControl'),
          },
          {
            path: KNOWLEDGEBASE_PATH.CATEGORIES,
            handle: {title: 'Categories'},
            lazy: () => import('components/pages/Knowledgebase/Categories/Categories'),
          },
          {
            path: `${KNOWLEDGEBASE_PATH.CATEGORIES}/:categoryId`,
            handle: {title: 'Categories'},
            lazy: () => import('components/pages/Knowledgebase/Categories/CreateCategories'),
          },
          {
            path: KNOWLEDGEBASE_PATH.CUSTOMIZATION,
            handle: {title: 'Customization'},
            lazy: () => import('components/pages/Knowledgebase/Customization/Customization'),
          },

          {
            path: KNOWLEDGEBASE_PATH.GENERAL,
            handle: {title: 'General'},
            lazy: () => import('components/pages/Knowledgebase/Settings/GeneralSetting'),
          },
          {
            path: KNOWLEDGEBASE_PATH.ADVANCED,
            handle: {title: 'Advance'},
            lazy: () => import('components/pages/Knowledgebase/Settings/AdvanceSetting'),
          },
          {
            path: KNOWLEDGEBASE_PATH.SEO,
            handle: {title: 'Seo'},
            lazy: () => import('components/pages/Knowledgebase/Settings/SeoSetting'),
          },
          {
            path: KNOWLEDGEBASE_PATH.VERSION_CONTROL,
            handle: {title: 'Version Control'},
            lazy: () => import('components/pages/Knowledgebase/Settings/VersionControlSetting'),
          },
          {
            path: KNOWLEDGEBASE_PATH.CUSTOM_CSS_JS,
            handle: {title: 'Custom Css Js'},
            lazy: () => import('components/pages/Knowledgebase/Settings/CustomCssAndJsSetting'),
          },
          {
            path: KNOWLEDGEBASE_PATH.REDIRECT_RULES,
            handle: {title: 'Redirect Rules'},
            lazy: () => import('components/pages/Knowledgebase/Settings/RedirectRulesSetting'),
          },
          {
            path: KNOWLEDGEBASE_PATH.IMPORT_EXPORT,
            handle: {title: 'Import & Export'},
            lazy: () => import('components/pages/Knowledgebase/Settings/ImportExport'),
          },
        ],
      },
      {
        path: `:id/${KNOWLEDGEBASE_PATH.ARTICLES}/:articleId`,
        handle: {title: 'Articles'},
        lazy: () => import('components/pages/Knowledgebase/Articles/CreateArticleForm'),
      },
    ],
  },
]

export default knowledgebaseRoutes
